import styled from '@emotion/styled'
import Link from 'next/link'

import Button from 'components/Button'

export const StyledButton = styled(Button)`
	align-self: end;
	margin-top: 20px;
`

export const Title = styled.h2`
	margin-top: 0;
	${({ theme }) => theme.typography.subHeading}
	align-self: flex-start;
`

export const Caption = styled.p`
	${({ theme }) => theme.typography.caption}
`

export const LoaderOuter = styled.div`
	width: 100%;
	display: grid;
	height: 150px;
	place-items: center;
`

export const StyledLink = styled(Link)`
	color: ${({ theme }) => theme.colors.light.primaryTextColor};
`

export const ButtonRow = styled.div`
	display: flex;
	flex-direction: row;
	align-self: end;
	gap: ${({ theme }) => theme.spaces.space4};
`
